import {Component, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    year: number = 0;
    version: string = environment.version;

    constructor() {
    }

    ngOnInit() {
        if (this.year === 0) {
            this.year = new Date().getFullYear();
        }
    }

}
